import {combineReducers} from 'redux';
import vendedorReducer from './vendedor.reducer';

const rootReducer = combineReducers({
    vendedorReducer
});

export default rootReducer;